import { render, staticRenderFns } from "./ChatsContent.vue?vue&type=template&id=68d364c4&scoped=true&"
import script from "./ChatsContent.vue?vue&type=script&lang=js&"
export * from "./ChatsContent.vue?vue&type=script&lang=js&"
import style0 from "./ChatsContent.vue?vue&type=style&index=0&id=68d364c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d364c4",
  null
  
)

export default component.exports